const one_day = 24 * 60 * 60 * 1000;
const devEnv_ =
  window?.location?.host.includes("localhost") ||
  window?.location?.host.includes("127.0.0") ||
  window?.location?.host.includes("preprod");
const devEnv = devEnv_;
export const keepAliveFrequencyTimeOptions = [
  devEnv ? 60 * 1000 : null,
  devEnv ? 2 * 60 * 1000 : null,
  one_day * 7,
  one_day * 14,
  one_day * 30,
  one_day * 60,
  one_day * 90,
  one_day * 180,
].filter((value) => value !== null);
export const selfRecoveryTimeOptions = [
  devEnv ? 60 * 1000 : null,
  devEnv ? 2 * 60 * 1000 : null,
  one_day * 7,
  one_day * 14,
  one_day * 30,
  one_day * 60,
  one_day * 90,
  one_day * 180,
].filter((value) => value !== null);
export const beneficiaryDelayTimeOptions = [
  devEnv ? 60 * 1000 : null,
  devEnv ? 2 * 60 * 1000 : null,
  one_day * 14,
  one_day * 30,
  one_day * 60,
  one_day * 90,
  one_day * 180,
].filter((value) => value !== null);
